<script setup lang="ts">
import { ref } from 'vue';
import { Typography } from './core';

type Props = {
  label?: string;
}

const props = defineProps<Props>();
const id = ref(crypto.randomUUID());
</script>
<template>
  <slot :id="id" />
  <slot :id="id" name="label">
    <Typography variant="form-label" class="cursor-pointer" :for="id">
      {{ props.label }}
    </Typography>
  </slot>
</template>
